<template>
    <div class="xcard">
        <v-data-table
            :headers="headers"
            :loading="loading"
            :items="desserts"
            :items-per-page="5" 
            class="elevation-1">

            <template v-slot:item.data="{ item }"> 
                <table class="xtablon">
                    <thead>
                        <tr>
                            <th>campo</th>
                            <th>anterior</th>
                            <th>Nuevo</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(c,i) in item.xcampos" :key="i">
                            <td class="link" >{{ c.campo }}</td>
                            <td>{{ c.oldValue }}</td>
                            <td>{{ c.newValue }}</td>
                        </tr> 
                    </tbody>
                </table>
            </template>

        </v-data-table>
    </div>
</template>

<style>
.xtablon tbody td:nth-child(2) {
    color: black!important;
}

.xtablon {
  width: 100%;
  border-collapse: collapse;
}
.xtablon th,
.xtablon td {
  border: 1px solid #d6d6d6;
  padding: 8px;
  text-align: left;
}
</style>
  
<script>
import xaxios from '@/xaxios'

export default {
    data(){
        return{
            loading: false,
            user_id: null, 
            headers: [ 
                { text: 'Fecha', value: 'updated_at' },
                { text: 'Realizado por', value: 'user' },
                { text: 'Contexto', value: 'context' },
                { text: 'Tipo', value: 'method' },
                { text: 'Modificaciones', value: 'data' },
            ],
            desserts: []
        }
    },
    methods:{
        async getHistorial(){
            this.desserts = [];
            this.loading = true;
            const url = process.env.VUE_APP_AUDIT+'/personas/id/'+this.user_id
            const res = await xaxios.get(url);
            if(res && res.data){
                res.data.forEach(x=>{
                    x.user = `${x.user_id} - ${x.name_user}`;
                    window.console.log('>>>>', x.data);
                    const fields = [];

                    for (const outerKey in x.data) {
                        if (x.data.hasOwnProperty(outerKey)) {
                            const obj = {}
                            obj.campo = outerKey;
                            
                            for (const innerKey in x.data[outerKey]) {
                                if (x.data[outerKey].hasOwnProperty(innerKey)) {
                                    obj[innerKey] = x.data[outerKey][innerKey]
                                }
                            }

                            fields.push(obj);
                        }
                    }

                    x.xcampos = fields;
                })
                this.desserts = res.data;
            }
            this.loading = false;
        }
    },
    mounted(){
        this.user_id = this.$route.query.id; 
        if(this.user_id){
            this.getHistorial();
        }
    }
}
</script>
